import React from 'react';
import { Navigate } from 'react-router-dom';
import { tenantDocPages } from '../../config/pages.config';

const DocumentationDocPage = () => (
	<Navigate to={tenantDocPages.documentationPage.subPages.customersPage.to} />
);

export default DocumentationDocPage;
